var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";

import Form from "@rjsf/material-ui";

import CustomObjectFieldTemplate from "./widgets/CustomObjectFieldTemplate";
import CustomObjectField from "./widgets/CustomObjectField";
import CustomArrayField from "./widgets/CustomArrayField";

import ViewFieldTemplate from "./view-widgets/ViewFieldTemplate";
import DateWidget from "./view-widgets/DateWidget";
import LocationWidget from "./view-widgets/LocationWidget";
import SelectWidget from "./view-widgets/SelectWidget";
import TableEditableWidget from "./view-widgets/TableEditableWidget";
import TextFieldWidget from "./view-widgets/TextFieldWidget";

import TitleWidget from "./widgets/mui/TitleWidget";
import RichTextField from "./widgets/RichTextField";
import LinkWidget from "./widgets/mui/LinkWidget";
import ParagraphWidget from "./widgets/mui/ParagraphWidget";

import MultipleUploadWidget from "./widgets/mui/MultipleUploadWidget";

import { formToJSONSchema, formToUISchema } from "./formTransformer";

export function FormViewer(_ref) {
  var form = _ref.form,
      formData = _ref.formData,
      environment = _ref.environment,
      customWidgets = _ref.customWidgets,
      rest = _objectWithoutProperties(_ref, ["form", "formData", "environment", "customWidgets"]);

  var formProps = _extends({}, rest, {
    tagName: "div",
    className: "container-fluid",
    schema: formToJSONSchema(form),
    uiSchema: formToUISchema(form, environment),
    formData: formData,
    FieldTemplate: ViewFieldTemplate,
    ObjectFieldTemplate: CustomObjectFieldTemplate,
    fields: {
      ArrayField: CustomArrayField,
      ObjectField: CustomObjectField
    }
  });

  var formWidgets = _extends({
    TextareaWidget: TextFieldWidget,
    number: TextFieldWidget,
    TextWidget: TextFieldWidget,
    dateWidget: DateWidget,
    titleWidget: TitleWidget,
    // radio: RadioGroupWidget,
    // checkboxes: CheckboxesGroupWidget,
    "file-multiple": MultipleUploadWidget,
    select: SelectWidget,
    richTextWidget: RichTextField,
    link: LinkWidget,
    location: LocationWidget,
    "table-editable": TableEditableWidget,
    mask: TextFieldWidget,
    paragraph: ParagraphWidget,
    "input-cpf": TextFieldWidget,
    "input-cnpj": TextFieldWidget,
    "input-decimal": TextFieldWidget
  }, customWidgets);

  return React.createElement(
    Form,
    _extends({}, formProps, { widgets: formWidgets }),
    React.createElement("div", null)
  );
}